import React, { Component } from "react";
import { TextField } from "reactackle";
import PhotoCard from "./PhotoCard";

class BazarCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContact: false,
      fieldList: {
        worker: ["mobile", "name", "address", "requestedItems"],
        grocer: ["mobile", "name", "requestedItems"],
        all: [
          "deliveryDate",
          "mobile",
          "name",
          "address",
          "requestedItems",
          "status",
          "supplier",
          "supplierPrice",
          "supplierNotes",
          "supplierPrices"
        ]
      }
    };
  }

  likeHandler = () => {
    let data = _.cloneDeep(this.props.data);
    if (data.likes && data.likes.length > 0) {
      if (
        data.likes.includes(this.props.firebase.auth.currentUser.phoneNumber)
      ) {
        data.likes = data.likes.filter(
          num => num !== this.props.firebase.auth.currentUser.phoneNumber
        );
      } else {
        data.likes.push(this.props.firebase.auth.currentUser.phoneNumber);
      }
    } else {
      data["likes"] = [];
      data.likes.push(this.props.firebase.auth.currentUser.phoneNumber);
    }
    if (data && data.key && data.key !== "") {
      let cloudPath = this.props.path + "/" + data.key;

      this.props.firebase.db
        .ref("/" + cloudPath)
        .once("value")
        .then(snap => {
          // this.props.onNotifyUsers(
          //   data.name + " says: " + this.refs.searchText.value,
          //   this.props.allSuppliers,
          //   false
          // );

          return snap.ref.set(data);
        })
        .catch(err => {
          console.log(err);
          alert("Message could not be sent. " + err);
          return "";
        })
        .then(err => {});
    }
  };

  saveHandler = () => {
    if (
      this.state.message &&
      this.state.message.msgText &&
      this.state.message.msgText.length > 0
    ) {
      let data = _.cloneDeep(this.props.data);
      if (data.messages && data.messages.length > 0) {
        data.messages.push(this.state.message);
      } else {
        data["messages"] = [];
        data.messages.push(this.state.message);
      }
      let notifyTgt = [];
      for (let i = 0; i < data.messages.length; i++) {
        let numb = data.messages[i].author;
        if (!notifyTgt.includes(numb.replace("+65", ""))) {
          notifyTgt.push(numb.replace("+65", ""));
        }
      }
      if (!notifyTgt.includes(data.author.replace("+65", ""))) {
        notifyTgt.push(data.author.replace("+65", ""));
      }

      //console.log(JSON.stringify(notifyTgt));
      if (data && data.key && data.key !== "") {
        let cloudPath = this.props.path + "/" + data.key;

        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            this.props.onNotifyUsers(
              this.state.message.author +
                " commented on open bazar post: " +
                this.state.message.msgText,
              notifyTgt,
              false
            );
            this.setState({
              message: {
                author: this.props.phoneNumber,
                msgText: ""
              }
            });
            return snap.ref.set(data);
          })
          .catch(err => {
            console.log(err);
            alert("Message could not be sent. " + err);
            return "";
          })
          .then(err => {});
      }
    }
  };

  getMessages = () => {
    let msgs = this.props.data.messages;
    if (msgs && msgs.length > 0) {
      return msgs.map(msg => {
        const fromMe = this.props.phoneNumber === msg.author ? "from-me" : "";

        return (
          <div className={`message ${fromMe}`}>
            <div className="username">
              {msg.author.substring(0, 7) + "****"}
            </div>
            <div className="message-body">{msg.msgText}</div>
          </div>
        );
      });
    }
  };

  getMessageSection = () => {
    return (
      <div>
        <hr
          style={{
            margin: "0px"
          }}
        />
        <div
          style={{
            minHeight: "40px",
            padding: "5px"
          }}
        >
          {this.getMessages()}
        </div>
      </div>
    );
  };

  getBazarCard = () => {
    let rec = this.props.data;
    let index = this.props.index;

    return (
      <div
        style={{
          background: "#FFFFFF",
          border: "1.5px solid #ccc",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          marginBottom: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            direction: "row",
            margin: "10px"
          }}
        >
          <div>
            <div
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "35px",
                backgroundColor: "gainsboro",
                border: "0.5px solid gray"
              }}
            ></div>
          </div>
          <div
            style={{
              lineHeight: "30px",
              paddingLeft: "5px",
              textTransform: "uppercase"
            }}
          >
            <div
              style={{
                lineHeight: "20px"
              }}
            >
              {rec.name}
            </div>
            <div
              style={{
                lineHeight: "10px"
              }}
            >
              <span
                style={{
                  fontSize: "10px"
                }}
              >
                {" "}
                {rec.author.substring(0, 7) + "****"}
              </span>
            </div>
          </div>
        </div>
        <div
          style={{
            paddingLeft: "10px"
          }}
        >
          <h2
            style={{
              marginTop: "5px",
              fontSize: "18px",
              fontWeight: "bold",
              textTransform: "uppercase"
            }}
          >
            {rec.title}
          </h2>
          {(rec.messageType === "SELLING" || rec.messageType === "BUYING") && (
            <div>
              <span
                style={{
                  marginTop: "-10px",
                  marginBottom: "0px",
                  marginLeft: "0px",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  backgroundColor: "black",
                  padding: "2px",
                  borderRadius: "10px",
                  color: "white",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  textTransform: "uppercase"
                }}
              >
                PRICE: {rec.price}
              </span>
            </div>
          )}
        </div>
        <div
          style={{
            marginLeft: "1px",
            marginRight: "1px"
          }}
        >
          <PhotoCard photos={rec.photos} />
        </div>

        <div
          style={{
            padding: "10px",
            marginTop: rec.photos && rec.photos.length > 0 ? "10px" : "-10px"
          }}
        >
          <div
            style={{
              margin: "5px"
            }}
          ></div>
          {rec.message}

          <div
            style={{
              margin: "5px",
              marginBottom: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end"
            }}
            onClick={() => {
              this.setState(prevState => {
                return {
                  ...prevState,
                  showComments: !prevState.showComments
                };
              });
            }}
          >
            {!this.state.showComments && (
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={"fa fa-eye"}
                  style={{ color: "rgb(30, 101, 144)" }}
                />
              </span>
            )}
            {this.state.showComments && (
              <span
                style={{
                  marginRight: "3px"
                }}
              >
                <icon
                  className={"fa fa-eye-slash"}
                  style={{ color: "rgb(30, 101, 144)" }}
                />
              </span>
            )}
            <span>
              {this.state.showComments ? "Hide Comments" : "View Comments"}
            </span>
          </div>
          {this.state.showComments && this.getMessageSection()}
          <hr
            style={{
              margin: "0px",
              marginBottom: "5px"
            }}
          />
          <div
            style={{
              display: "flex",
              direction: "row"
            }}
          >
            <div
              style={{
                width: "100%",
                border: "1px solid gainsboro"
              }}
            >
              <TextField
                bordered
                ref={"searchText"}
                value={
                  this.state.message && this.state.message.msgText
                    ? this.state.message.msgText
                    : ""
                }
                onChange={e => {
                  //console.log("value changed" + JSON.stringify(e));
                  this.setState({
                    message: {
                      author: this.props.phoneNumber,
                      msgText: e.value
                    }
                  });
                }}
                fullWidth
                multiline
                multilineRows={{ min: 2 }}
              />
            </div>
            <div
              onClick={this.saveHandler}
              style={{
                width: "60px",
                margin: "2px",
                textAlign: "center",
                height: "35px",
                /* background-color: blue; */
                lineHeight: "35px",
                border: "1px solid white",
                marginTop: "5px",
                marginBottom: "5px",
                marginLeft: "10px",
                backgroundColor: "rgb(30, 101, 144)",
                color: "white"
              }}
            >
              Send
            </div>
          </div>
          <hr
            style={{
              margin: "5px",
              marginTop: "5px"
            }}
          />
          <div
            style={{
              display: "flex",
              direction: "row"
            }}
          >
            <div
              style={{
                width: "30%"
              }}
            >
              {/* {rec.author === this.props.phoneNumber && (
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "12px"
                  }}
                  onClick={() => {
                    this.props.handleEdit(
                      rec.key,
                      this.props.tableName,
                      rec,
                      "openBazar"
                    );
                  }}
                >
                  <span
                    style={{
                      margin: "3px",
                      fontSize: "12px"
                    }}
                  >
                    <icon className="fa fa-edit" />
                  </span>
                  <span
                    style={{
                      fontSize: "10px"
                    }}
                  >
                    {" "}
                    TAP TO CHANGE
                  </span>
                </div> */}
              {rec.author === this.props.phoneNumber && (
                <div
                  style={{
                    margin: "3px",
                    display: "flex",
                    direction: "row"
                  }}
                  onClick={() => {
                    this.props.handleEdit(
                      rec.key,
                      this.props.tableName,
                      rec,
                      "openBazar"
                    );
                  }}
                >
                  <div
                    style={{
                      margin: "1px"
                    }}
                  >
                    <icon className={"fa fa-edit"} />
                  </div>

                  <div
                    style={{
                      minWidth: "5px",
                      textAlign: "center",
                      margin: "auto",
                      fontSize: "10px"
                    }}
                  >
                    TAP TO CHANGE
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "16px",
                display: "flex",
                direction: "row",
                justifyContent: "flex-end"
              }}
            >
              <div
                style={{
                  marginLeft: "10px",
                  display: "flex",
                  direction: "row"
                }}
              >
                <div
                  style={{
                    margin: "3px"
                  }}
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        ...prevState,
                        showComments: !prevState.showComments
                      };
                    });
                  }}
                >
                  <icon className={"fa fa-comment-o"} />
                </div>

                <div
                  style={{
                    minWidth: "5px",
                    textAlign: "center",
                    margin: "auto"
                  }}
                >
                  {rec.messages && rec.messages.length > 0
                    ? rec.messages.length
                    : ""}
                </div>
              </div>

              <div
                style={{
                  marginLeft: "10px",
                  display: "flex",
                  direction: "row"
                }}
                onClick={() => {
                  this.likeHandler();
                }}
              >
                <div
                  style={{
                    margin: "3px"
                  }}
                >
                  {rec.likes &&
                    rec.likes.length > 0 &&
                    rec.likes.includes(
                      this.props.firebase.auth.currentUser.phoneNumber
                    ) && (
                      <icon
                        className={"fa fa-heart"}
                        style={{ color: "red" }}
                      />
                    )}
                  {(!rec.likes ||
                    (rec.likes &&
                      rec.likes.length > 0 &&
                      !rec.likes.includes(
                        this.props.firebase.auth.currentUser.phoneNumber
                      ))) && <icon className={"fa fa-heart-o"} />}
                </div>

                <div
                  style={{
                    minWidth: "5px",
                    textAlign: "center",
                    margin: "auto"
                  }}
                >
                  {rec.likes && rec.likes.length > 0 ? rec.likes.length : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    return <div>{this.getBazarCard()}</div>;
  }
}

export default BazarCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/BazarCard.jsx